import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDashboardId } from '@/hooks';
import { getDashboardsState } from '@/store-selectors';
import { loadPublicDashboard } from '@/actions';
import Dashboard from '@/components/Dashboard';
import AjaxSpinner from '@/components/AjaxSpinner';
import PinComponent from '@/components/PinComponent';
import { useAppDispatch } from '@/store/hooks';
import { PUBLIC_DASHBOARD } from '@/features/dashboard/types';

const SharedDashboard = () => {
  const dispatch = useAppDispatch();
  const dashboardId = useDashboardId();
  const [searchParams] = useSearchParams();
  const dashboards = useSelector(getDashboardsState);
  const [enteredPin, setEnteredPin] = React.useState('');

  const urlPin = searchParams.get('pin');

  const pin = urlPin || enteredPin;

  React.useEffect(() => {
    if (pin) dispatch(loadPublicDashboard(dashboardId, pin));
  }, [dashboardId, pin]);

  if (!pin && !dashboards.active) {
    return <PinComponent onPinReady={setEnteredPin} />;
  }

  if (!dashboards.active) {
    return (
      <div className="spinnerContainer">
        <AjaxSpinner />
      </div>
    );
  }

  return (
    <div className="dashboards">
      <Dashboard
        state={dashboards}
        // eslint-disable-next-line react/function-component-definition
        userInteraction={() => () => null}
        restricted={null}
        onAddWidget={null}
        onOpenView={() => null}
        onSave={null}
        onDiscard={null}
        onAwaitingWidgetData={() => null}
        dashboardType={PUBLIC_DASHBOARD}
        onRefreshClicked={null}
      />
    </div>
  );
};

export default SharedDashboard;
